// extracted by mini-css-extract-plugin
export var CollapsedWrapper = "Nav-module--CollapsedWrapper--ba3a8";
export var FadeOverlay = "Nav-module--FadeOverlay--2ceeb";
export var MainNav = "Nav-module--MainNav--d46fd";
export var MenuButtons = "Nav-module--MenuButtons--8b949";
export var NewNavWrapper = "Nav-module--NewNavWrapper--1bb17";
export var Next = "Nav-module--Next--ae391";
export var Prev = "Nav-module--Prev--173e1";
export var SocialLinks = "Nav-module--SocialLinks--8db04";
export var SuperWrapper = "Nav-module--SuperWrapper--75c4c";
export var Wrapper = "Nav-module--Wrapper--27e3d";